/* eslint-disable */
jQuery(function($) {
    function copyToClipboard(element) {
        var $temp = $("<input>");

        $("body").append($temp);

        $temp.val($(element).data('clipboard-text')).select();

        document.execCommand("copy");

        $temp.remove();
    }


    $(document).on('click', '.ebanx-button--copy', function() {
        copyToClipboard('.ebanx-button--copy')
    })
});
